import { userStore } from '@/stores/user'
import { loadChatbot } from '@/utils/common'

const routes = [
  {
    path: '/',
    component: () => {},
    beforeEnter: () => {
      const user = userStore()
      if (user.isAuthenticated) {
        const lastRoute = localStorage.getItem('lastRoute')
        if (lastRoute) {
          localStorage.removeItem('lastRoute')
          return lastRoute
        }
        return { name: 'Dashboard' }
      }
      return { name: 'Login' }
    }
  },

  {
    path: '/login',
    component: () => import('@/layouts/LoginLayout.vue'),
    beforeEnter: () => {
      const user = userStore()
      if (user.isAuthenticated) {
        return { name: 'Dashboard' }
      }
      loadChatbot()
    },
    children: [
      { path: '', name: 'Login', component: () => import('@/pages/LoginPage.vue'), props: { registrationDialog: false, faqDialog: false, forgotPasswordDialog: false } },
      { path: 'registrierung', name: 'Registration', component: () => import('@/pages/LoginPage.vue'), props: { registrationDialog: true, faqDialog: false, forgotPasswordDialog: false } },
      { path: 'hilfe', name: 'PublicFAQ', component: () => import('@/pages/LoginPage.vue'), props: { faqDialog: true, registrationDialog: false, forgotPasswordDialog: false } },
      { path: 'passwort-vergessen', name: 'PasswortVergessen', component: () => import('@/pages/LoginPage.vue'), props: { forgotPasswordDialog: true, faqDialog: false, registrationDialog: false } },
      { path: 'passwort-reset', name: 'PasswortReset', component: () => import('@/pages/PasswordResetPage.vue') },
      { path: 'token/:uuid', name: 'TokenLogin', props: true, component: () => import('@/pages/TokenLoginPage.vue') }
    ]
  },

  {
    path: '/aktivierung',
    component: () => import('@/layouts/LoginLayout.vue'),
    beforeEnter: () => {
      const user = userStore()
      if (user.isAuthenticated) {
        return { name: 'Dashboard' }
      }
      loadChatbot()
    },
    children: [
      { path: '', name: 'Aktivierung', component: () => import('@/pages/AktivierungPage.vue') }
    ]
  },

  {
    path: '/secure',
    beforeEnter: to => {
      const user = userStore()
      if (!user.isAuthenticated) {
        return { name: 'Login', query: { returnTo: to.fullPath } }
      }
      loadChatbot()
    },
    component: () => import('@/layouts/MainLayout.vue'),
    children: [
      { path: '', component: () => import('@/pages/IndexPage.vue') },
      { path: 'dashboard', name: 'Dashboard', component: () => import('@/pages/DashboardPage.vue') },
      {
        path: 'nebenkosten',
        component: () => import('@/pages/NebenkostenPage.vue'),
        children: [
          { path: '', name: 'Nebenkosten', component: () => import('@/pages/KostenOverviewPage.vue') },
          { path: 'betriebskosten', name: 'Betriebskosten', component: () => import('@/pages/KostenDetailPage.vue') },
          { path: 'heizkosten', name: 'Heizkosten', component: () => import('@/pages/KostenDetailPage.vue') },
          { path: 'wasserkosten', name: 'Wasserkosten', component: () => import('@/pages/KostenDetailPage.vue') },
          { path: 'vorauszahlungen', name: 'Vorauszahlungen', component: () => import('@/pages/VorauszahlungenPage.vue') },
          {
            path: 'uvi',
            name: 'UVI',
            redirect: { name: 'UviDashboard' },
            children: [
              { path: 'dashboard', name: 'UviDashboard', component: () => import('@/pages/UviDashboardPage.vue') },
              { path: ':uviType', name: 'UviDetail', component: () => import('@/pages/UviDetailPage.vue') }
            ]
          }
        ]
      },
      { path: 'vorteile-angebote', name: 'VorteileAngebote', component: () => import('@/pages/VorteileAngebotePage.vue') },
      {
        path: 'dokumente',
        name: 'Dokumente',
        component: () => import('@/pages/DokumentePage.vue'),
        children: [
          { path: ':parents', component: () => import('@/pages/DokumentePage.vue') }
        ]
      },
      {
        path: 'nachrichten',
        name: 'Nachrichten',
        component: () => import('@/pages/NachrichtenPage.vue'),
        children: [
          { path: '', name: 'NachrichtenBox', meta: { safePaddingDisabled: true }, component: () => import('@/pages/NachrichtenBoxPage.vue') },
          { path: 'detail/:vorgangsId', name: 'NachrichtenDetail', meta: { safePaddingDisabled: true, hideChatbotButton: true }, props: true, component: () => import('@/pages/NachrichtenDetailPage.vue') },
          { path: 'neu', name: 'NachrichtenNew', component: () => import('@/pages/NachrichtenNewPage.vue') }
        ]
      },
      {
        path: 'schluesselnachbestellung',
        name: 'Schluesselnachbestellung',
        component: () => import('@/pages/SchluesselnachbestellungPage.vue')
      },
      {
        path: 'vertragskonto',
        name: 'Vertragskonto',
        component: () => import('@/pages/VertragskontoPage.vue')
      },
      {
        path: 'vertragsdaten',
        name: 'Vertragsdaten',
        component: () => import('@/pages/VertragsdatenPage.vue')
      },
      {
        path: 'kuendigung',
        name: 'Kuendigung',
        component: () => import('@/pages/VertragKuendingenPage.vue')
      },
      {
        path: 'kundendaten',
        name: 'Kundendaten',
        component: () => import('@/pages/KundendatenPage.vue')
      },
      {
        path: 'anmeldedaten',
        name: 'Anmeldedaten',
        component: () => import('@/pages/AnmeldedatenPage.vue')
      },
      {
        path: 'passwort-aendern',
        name: 'PasswortChange',
        component: () => import('@/pages/PasswortChangePage.vue')
      },
      {
        path: 'appwash',
        name: 'AppWash',
        component: () => import('@/pages/AppWashPage.vue')
      },
      {
        path: 'nachweise',
        name: 'Nachweise',
        component: () => import('@/pages/NachweisePage.vue')
      },
      {
        path: 'schadensmeldungen',
        children: [
          { path: '', name: 'Schadensmeldungen', meta: { safePaddingDisabled: true, hideChatbotButton: true }, component: () => import('@/pages/SchadensmeldungenPage.vue') },
          { path: 'detail/:id', name: 'SchadensmeldungDetail', meta: { safePaddingDisabled: true, hideChatbotButton: true }, props: true, component: () => import('@/pages/SchadensmeldungDetailPage.vue') },
          {
            path: 'neu',
            component: () => import('@/pages/NeueSchadensmeldungPage.vue'),
            children: [
              { path: '', redirect: { name: 'NeueSchadensmeldung' } },
              { path: 'auswahl', name: 'NeueSchadensmeldung', meta: { hideChatbotButton: true }, component: () => import('@/components/NeueSchadensmeldung/AuswahlSchaden.vue') },
              { path: 'chat', name: 'ChatSchaden', meta: { safePaddingDisabled: true, hideChatbotButton: true }, component: () => import('@/components/NeueSchadensmeldung/ChatSchaden.vue') },
              { path: 'beschreibung', name: 'BeschreibungSchaden', meta: { hideChatbotButton: true }, component: () => import('@/components/NeueSchadensmeldung/BeschreibungSchaden.vue') },
              { path: 'zusammenfassung', name: 'ZusammenfassungSchaden', meta: { hideChatbotButton: true }, component: () => import('@/components/NeueSchadensmeldung/ZusammenfassungSchaden.vue') },
              { path: 'terminauswahl', name: 'TerminauswahlSchaden', meta: { hideChatbotButton: true }, component: () => import('@/components/NeueSchadensmeldung/TerminbuchungSchaden.vue') }
            ]
          }
        ]
      },
      {
        path: 'faq',
        name: 'FAQ',
        component: () => import('@/pages/FaqPage.vue'),
        children: [
          { path: ':category', name: 'FAQCategory', props: true, component: () => import('@/pages/FaqPage.vue') }
        ]
      },
      {
        path: 'wussten-sie-schon',
        name: 'WusstenSieSchon',
        component: () => import('@/pages/WusstenSieSchonPage.vue')
      },
      {
        path: 'mietanpassung',
        name: 'Mietanpassung',
        component: () => import('@/pages/MietanpassungPage.vue')
      },
      {
        path: 'einstellungen',
        name: 'Einstellungen',
        component: () => import('@/pages/EinstellungenPage.vue')
      },
      {
        path: 'secret-testing',
        name: 'SecretTesting',
        component: () => import('@/pages/SecretTestingPage.vue')
      },
      {
        path: 'impressum',
        name: 'Impressum',
        component: () => import('@/pages/ImpressumPage.vue')
      },
      {
        path: 'datenschutz',
        name: 'Datenschutz',
        component: () => import('@/pages/DatenschutzPage.vue')
      },
      {
        path: 'datenschutz-mieter',
        name: 'DatenschutzMieter',
        props: { container: true },
        component: () => import('@/pages/DatenschutzMieterPage.vue')
      },
      {
        path: 'nutzungsbedingungen',
        name: 'Nutzungsbedingungen',
        component: () => import('@/pages/NutzungsbedingungenPage.vue')
      },
      {
        path: 'homecoming',
        name: 'Homecoming',
        component: () => import('@/pages/HomecomingPage.vue')
      },
      {
        path: 'handwerkerservice',
        name: 'Handwerkerservice',
        component: () => import('@/pages/HandwerkerservicePage.vue')
      },
      {
        path: 'tipps-umzug',
        name: 'TippsUmzug',
        component: () => import('@/pages/TippsUmzugPage.vue')
      },
      {
        path: 'rauchmelder',
        name: 'Rauchmelder',
        component: () => import('@/pages/RauchmelderPage.vue')
      },
      {
        path: 'schoenheitsreparaturen',
        name: 'Schoenheitsreparaturen',
        component: () => import('@/pages/SchoenheitsreperaturenPage.vue')
      },
      {
        path: 'muelltrennung',
        name: 'Muelltrennung',
        component: () => import('@/pages/MuelltrennungPage.vue')
      },
      {
        path: 'stromausfall',
        name: 'Stromausfall',
        component: () => import('@/pages/StromausfallPage.vue')
      },
      {
        path: 'treppenhauslicht',
        name: 'Treppenhauslicht',
        component: () => import('@/pages/TreppenhauslichtPage.vue')
      },
      {
        path: 'fenster',
        name: 'Fenster',
        component: () => import('@/pages/FensterPage.vue')
      },
      {
        path: 'person-aus-vertrag-entlassen',
        name: 'PersonVertragEntlassen',
        component: () => import('@/pages/PersonVertragEntlassenPage.vue')
      },
      {
        path: 'warmwassernutzung',
        name: 'Warmwassernutzung',
        component: () => import('@/pages/WarmwassernutzungPage.vue')
      },
      {
        path: 'sozialberatung',
        name: 'Sozialberatung',
        component: () => import('@/pages/SozialberatungPage.vue')
      },
      {
        path: 'gewinnspiel/family-festival-2025',
        name: 'FamilyFestival',
        component: () => import('@/pages/FamilyFestivalPage.vue')
      },
      {
        path: 'gewinnspiel/family-festival-2025/teilgenommen',
        name: 'FamilyFestivalTeilgenommen',
        component: () => import('@/pages/FamilyFestivalTeilgenommenPage.vue')
      }
    ]
  },

  {
    path: '/impressum',
    component: () => import('@/layouts/LoginLayout.vue'),
    beforeEnter: () => {
      const user = userStore()
      if (user.isAuthenticated) {
        return { name: 'Impressum' }
      }
      loadChatbot()
    },
    children: [
      { path: '', name: 'ImpressumPublic', props: { container: true }, component: () => import('@/pages/ImpressumPage.vue') }
    ]
  },

  {
    path: '/datenschutz',
    component: () => import('@/layouts/LoginLayout.vue'),
    beforeEnter: () => {
      const user = userStore()
      if (user.isAuthenticated) {
        return { name: 'Datenschutz' }
      }
      loadChatbot()
    },
    children: [
      { path: '', name: 'DatenschutzPublic', props: { container: true }, component: () => import('@/pages/DatenschutzPage.vue') },
      { path: 'mieter', name: 'DatenschutzMieterPublic', props: { container: true }, component: () => import('@/pages/DatenschutzMieterPage.vue') }
    ]
  },

  {
    path: '/nutzungsbedingungen',
    component: () => import('@/layouts/LoginLayout.vue'),
    beforeEnter: () => {
      const user = userStore()
      if (user.isAuthenticated) {
        return { name: 'Nutzungsbedingungen' }
      }
      loadChatbot()
    },
    children: [
      { path: '', name: 'NutzungsbedingungenPublic', props: { container: true }, component: () => import('@/pages/NutzungsbedingungenPage.vue') }
    ]
  },

  {
    path: '/startup',
    component: () => import('@/layouts/DigiMvLayout.vue'),
    beforeEnter: () => {
      const user = userStore()
      if (user.isAuthenticated) {
        return { name: 'Dashboard' }
      }
    },
    children: [
      { path: 'banking/:guid', name: 'MietvertragBanking', props: true, component: () => import('@/pages/MietvertragBankingPage.vue') },
      { path: 'login/:guid', name: 'MietvertragLogin', props: true, component: () => import('@/pages/MietvertragLoginPage.vue') },
      { path: 'contract/:guid', name: 'MietvertragContract', props: true, component: () => import('@/pages/MietvertragContractPage.vue') },
      { path: 'qes_callback/:guid', name: 'MietvertragQesCallback', props: true, component: () => import('@/pages/MietvertragQesPage.vue') },
      { path: 'success/:guid', name: 'MietvertragSuccess', props: true, component: () => import('@/pages/MietvertragSuccessPage.vue') },
      { path: ':guid', name: 'MietvertragStartup', props: true, component: () => import('@/pages/MietvertragStartupPage.vue') }
    ]
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('@/pages/ErrorNotFound.vue')
  }
]

export default routes
